import jwtDecode from "jwt-decode";

export const IDP_TOKEN_KEY = "https://superblocks/api/idp_token";

export function extractIdpToken(auth0Jwt: string): string | undefined {
  try {
    const decoded: Record<string, unknown> = jwtDecode(auth0Jwt);
    const idpToken = decoded[IDP_TOKEN_KEY];
    return typeof idpToken === "string" ? idpToken : undefined;
  } catch {
    return undefined;
  }
}
